<template>
  <v-container>
    <v-toolbar flat color="white">
      <v-toolbar-title>Administración de usuarios</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
      <v-spacer></v-spacer>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="indigo" outline rounded dark class="mb-2" v-on="on">
            <v-icon color="yellow darken-2">add</v-icon>nuevo usuario
          </v-btn>
        </template>
        <v-card>
          <v-form ref="form" @submit="save" lazy-validation v-model="valid">
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :counter="30"
                      required
                      :rules="validationRules"
                      v-model="editedItem.first_name"
                      label="Nombres"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :counter="30"
                      required
                      :rules="validationRules"
                      v-model="editedItem.last_name"
                      label="Apellidos"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :counter="30"
                      required
                      :rules="validationRules"
                      v-model="editedItem.username"
                      label="Usuario"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :counter="30"
                      required
                      :rules="validationRules"
                      v-model="editedItem.password"
                      label="Contraseña"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat small color="error" @click="close">Cancelar</v-btn>
              <v-btn outline color="indigo" :disabled="!valid" type="submit">
                <v-icon color="indigo" style="margin-right:5px;">save</v-icon>Almacenar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      must-sort
      :headers="computedHeaders"
      :items="usuarios"
      :search="search"
      :pagination.sync="pagination"
      :rows-per-page-items="pagination.rowsPerPageItems"
      :total-items="pagination.totalItems"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td v-if="false">{{ props.item.id }}</td>
        <td>{{ props.item.first_name }}</td>
        <td>{{ props.item.last_name }}</td>
        <td>{{ props.item.username }}</td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="openDeleteDialog(props.item)">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Buscar datos de nuevo</v-btn>
      </template>
    </v-data-table>
    <!--DIALOGO DE ELIMINACION !-->
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-text>
          <v-layout justify-space-around>
            <v-icon x-large color="red" style="font-size: 85px;">report</v-icon>
          </v-layout>
        </v-card-text>
        <v-layout justify-space-around>
          <v-card-title class="title text-md-center">¿Estas seguro de querer eliminar este elemento?</v-card-title>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat small color="error" @click="cancelDelete()">No</v-btn>
          <v-btn flat="flat" outline small color="green darken-1" @click="deleteItem()">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { debuglog } from "util";
export default {
  data: () => ({
    dialog: false,
    deleteDialog: false,
    valid: true,
    search: "",
    validationRules: [
      v => !!v || "El campo es requerido",
      v => (v && v.length < 30) || "El campo no puede superar los 30 caracteres"
    ],
    headers: [
      {
        text: "Id",
        align: "left",
        sortable: true,
        value: "id"
      },
      {
        text: "Nombres",
        align: "left",
        sortable: true,
        value: "first_name"
      },
      {
        text: "Apellidos",
        align: "left",
        sortable: true,
        value: "last_name"
      },
      {
        text: "Usuario",
        align: "left",
        sortable: true,
        value: "username"
      },
      { text: "Acciones", value: "", sortable: false }
    ],
    usuarios: [],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 25,
      totalItems: 0,
      rowsPerPageItems: [25]
    },
    editedIndex: -1,
    editedItem: {
      id: null,
      nombres: null,
      apellidos: null
    },
    defaultItem: {
      nombres: null,
      apellidos: null
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo usuario" : "Editar usuario";
    },
    computedHeaders() {
      return this.headers.filter(header => header.text !== "Id");
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    search() {
      this.searchUsuarios(this.search);
    },
    pagination: {
      handler() {
        this.loading = true;
        this.$store.dispatch("changePage").then(result => {
          this.loading = false;
        });
      },
      deep: true
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      const that = this;
      this.$store
        .dispatch("getUsuarios")
        .then(response => {
          setTimeout(function() {
            that.usuarios = that.$store.getters.usuarios;
            that.pagination = that.$store.state.paginationUsuario;
          }, 200);
        })
        .catch(error => {
          console.log(error);
        });
    },

    editItem(item) {
      this.editedIndex = this.usuarios.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    searchUsuarios(query) {
      const that = this;
      this.$store
        .dispatch("searchUsuarios", query)
        .then(response => {
          setTimeout(function() {
            that.usuarios = that.$store.getters.usuarios;
            that.pagination = that.$store.state.paginationUsuario;
          }, 200);
        })
        .catch(error => {
          console.log(error);
        });
    },

    cleanModel() {
      this.editedItem = {
        id: null,
        first_name: "",
        last_name: "",
        username: "",
        password: ""
      };
      this.defaultItem = {
        first_name: "",
        last_name: "",
        username: "",
        password: ""
      };
      this.search = "";
    },

    openDeleteDialog(item) {
      this.editedIndex = this.usuarios.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.deleteDialog = true;
    },

    deleteItem() {
      const that = this;
      this.$store
        .dispatch("deleteUsuario", this.editedItem)
        .then(response => {
          that.initialize();
          that.cleanModel();
          that.cancelDelete();
        })
        .catch(error => {
          console.log(error);
        });
    },

    cancelDelete() {
      this.deleteDialog = false;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      const that = this;
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          this.$store
            .dispatch("updateUsuario", this.editedItem)
            .then(response => {
              that.initialize();
              that.cleanModel();
              that.close();
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          this.$store
            .dispatch("createUsuario", this.editedItem)
            .then(response => {
              that.initialize();
              that.cleanModel();
              that.close();
            })
            .catch(error => {
              console.log(error);
            });
        }
      } else {
        alert("por favor ingresa datos al formulario");
      }
    }
  }
};
</script>